/**
 * Prevents duplicate checkout submissions and shows a luxury loading
 * state on the checkout button the moment the cart form submits.
 */
(function () {
  function wire(button) {
    if (!button || button.dataset.luxWired) return;
    button.dataset.luxWired = 'true';
    const form = button.closest('form');
    if (!form) return;
    form.addEventListener('submit', (e) => {
      if (e.submitter !== button && document.activeElement !== button) return;
      if (button.classList.contains('is-loading')) {
        e.preventDefault();
        return;
      }
      button.classList.add('is-loading');
      button.disabled = true;
    });
  }

  function wireAll() {
    document.querySelectorAll('.cart__checkout-button').forEach(wire);
  }

  document.addEventListener('DOMContentLoaded', wireAll);
  document.addEventListener('cart:refresh-ui', wireAll);
  if (window.CartManager) {
    window.CartManager.on('cart:updated', wireAll);
  }
})();
